<template>
  <div>
    <base-header type class="rsgradient pb-3 pb-1 pt-3 pt-md-5"></base-header>

    <b-card style="margin: 20px">
      <b-card-header header-tag="header" class="p-1" role="tab">Verifica que esta cuenta te pertenece.</b-card-header>
      <b-card-body>
        <div class="row form-group">
          <div class="col-md-12">
           Elige cómo recibir el código de verificación.
          </div>
        </div>

         <div class="row form-group">
          <div class="col-md-12">
                 <label>Métodos de verificación</label>
            <div style="background-color: white; border-radius: 5px; border: #d6d4d4 1px solid">
              <div
                class="row"
                v-for="item in metodosVerificacion"
                @click="itemClicked(item)"
                v-bind:key="item.MethodID"
                :value="item.Name"
                style="padding: 5px; border-bottom: 1px solid #d6d4d4; cursor: pointer; margin-right: 0; margin-left: 0"
              >
                <div class="col-10" style="display: flex">
                  <img :src="getImgUrl(item.Icon)" class="" style="width: 50px" alt />
                  <div class="bold" style="margin-left: 10px">
                    <div><b>{{item.Name}}</b></div>
                    <div>{{item.MessageToShow}}</div>
                  </div>
                </div>
                <div class="col-2 text-right" style="padding-top: 10px; padding-right: 25px">
                     >
                </div>
              </div>
            </div>
          </div>
        </div>
        
      </b-card-body>
    </b-card>
  </div>
</template>

<style>

</style>

<script>

import Vue from "vue";
import ResimpleSwitch from "@/components/Custom/ResimpleSwitch";
import axiosHelpers from "@/helpers/axiosHelpers";
import notificationHelpers from "@/helpers/notificationHelpers";

export default {
  components: {"resimple-switch":ResimpleSwitch },
   props: {
        url: String,
        dataPost: Object,
        accumulationMethodTypeID: Number,
        useRouterPush: Boolean
      },
  data() {
    return {
      model: { Email: "",URL:this.url,DataPost:this.dataPost },
      metodosVerificacion: []
    };
  },
  
  methods: {
            getImgUrl(pic) {
                    return "/img/icons/"+pic
            },
           
            itemClicked(item) {
              let context = this;
              var param = { SelectedMethodID:item.MethodID, Aux: item.Value };
              axiosHelpers.axiosPost("DoubleFactorSecurity/GenerateSecurityCodeAndSend", param, this, function(data) { 
                 if(data.ResponseVM.Result){
                    context.$router.push({name: "InitialValidateSecurityCode", params:{url:context.model.URL,dataPost:context.model.DataPost,methodID:item.MethodID, accumulationMethodTypeID: context.accumulationMethodTypeID, useRouterPush: context.useRouterPush}});
                 }
              });
            }
            
    },
    beforeMount: function() {
            let context = this;
            axiosHelpers.axiosPost("DoubleFactorSecurity/EnableAccountVerificationMethods", {}, this, function(data) {
            context.metodosVerificacion = data.ResponseVM.Items;
            });
    }
  }

</script>